// Registrar novo usuário

import { api } from "../../index";

export const register = async (userData: {
  nome_completo: string;
  email: string;
  senha: string;
  telefone: string;
}) => {
  const response = await api.post("/register", userData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
